import { DataTableColumn } from '@/components/DataTable';

export const getSearchUsersColumns = <
  T extends { name: string; email: string; userRole: string }
>(): DataTableColumn<T>[] => {
  return [
    {
      field: 'name',
      headerName: 'NAME',
      width: '33%',
      sortable: true,
      renderCell: ({ row }) => row.name || ''
    },
    {
      field: 'email',
      headerName: 'EMAIL',
      width: '33%',
      sortable: true,
      renderCell: ({ row }) => row.email || ''
    },
    {
      field: 'userRole',
      headerName: 'USER ROLE',
      width: '34%',
      sortable: true,
      renderCell: ({ row }) => row.userRole || ''
    }
  ];
};
